import { render, staticRenderFns } from "./AudienceBulkAddToProductModal.vue?vue&type=template&id=30c7fd4a&scoped=true"
import script from "./AudienceBulkAddToProductModal.vue?vue&type=script&lang=js"
export * from "./AudienceBulkAddToProductModal.vue?vue&type=script&lang=js"
import style0 from "./AudienceBulkAddToProductModal.vue?vue&type=style&index=0&id=30c7fd4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c7fd4a",
  null
  
)

export default component.exports